import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { setLanguagePreference } from '@/services/clientConfig'

const FlagGB = () => (
  <svg viewBox="0 0 60 30" aria-hidden="true">
    <clipPath id="flag-gb-clip"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
    <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
    <path d="M0,0 L60,30 M60,0 L0,30" stroke="#ffffff" strokeWidth="6" />
    <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#flag-gb-clip)" stroke="#C8102E" strokeWidth="4" />
    <path d="M30,0 v30 M0,15 h60" stroke="#ffffff" strokeWidth="10" />
    <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
  </svg>
)

const FlagPL = () => (
  <svg viewBox="0 0 16 10" aria-hidden="true">
    <rect width="16" height="5" fill="#ffffff" />
    <rect y="5" width="16" height="5" fill="#DC143C" />
  </svg>
)

const LANGUAGES = [
  { code: 'en', Flag: FlagGB },
  { code: 'pl', Flag: FlagPL },
]

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation()
  const current = i18n.resolvedLanguage || i18n.language

  const handleChange = (code) => {
    setLanguagePreference(code)
    i18n.changeLanguage(code)
  }

  return (
    <Switcher role="group" aria-label={t('language.switch')}>
      {LANGUAGES.map(({ code, Flag }) => (
        <FlagButton
          key={code}
          type="button"
          $active={current === code}
          aria-pressed={current === code}
          title={t(`language.${code}`)}
          onClick={() => handleChange(code)}
        >
          <Flag />
          <span>{code.toUpperCase()}</span>
        </FlagButton>
      ))}
    </Switcher>
  )
}

export default LanguageSwitcher

const Switcher = styled.div`
  display: flex;
  gap: 8px;
`

const FlagButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 80px;
  height: 48px;
  padding: 0 14px;
  border: none;
  border-radius: var(--radius-control, 12px);
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;

  svg {
    width: 24px;
    height: 16px;
    border-radius: 3px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
    display: block;
    opacity: 0.8;
    transition: opacity 0.12s;
  }

  &:active {
    background: rgba(255, 255, 255, 0.2);
  }

  ${({ $active, theme }) => $active && css`
    background: #ffffff;
    color: ${theme.colors.global};

    svg {
      opacity: 1;
    }

    &:active {
      background: #ffffff;
    }
  `}
`
